{
  "title": "Companies",
  "subtitle": "Platform-wide company management — visible only to SuperAdmin accounts.",
  "addCompany": "Add Company",
  "table": {
    "name": "Company",
    "cin": "CIN",
    "gstin": "GSTIN",
    "currency": "Currency",
    "branches": "Branches",
    "status": "Status",
    "createdDate": "Created"
  },
  "actions": {
    "processConfig": "Process Config",
    "edit": "Edit",
    "delete": "Delete",
    "cancel": "Cancel"
  },
  "deleteCompany": {
    "message": "This will permanently delete \"{{name}}\" and all of its data. This cannot be undone."
  },
  "onboard": {
    "title": "Add Company",
    "submit": "Create Company",
    "genericError": "Could not create the company. Please check the details and try again.",
    "sections": {
      "company": "Company Details",
      "branch": "First Branch",
      "admin": "First Administrator Login"
    }
  },
  "form": {
    "companyName": "Company Name",
    "cin": "CIN",
    "gstin": "GSTIN",
    "email": "Primary Contact Email",
    "industrySector": "Industry Sector",
    "currency": "Currency",
    "taxSystem": "Tax System",
    "branchCode": "Branch Code",
    "branchName": "Branch Name",
    "branchAddress": "Branch Address",
    "adminUsername": "Admin Username",
    "adminEmail": "Admin Email",
    "adminPassword": "Admin Password",
    "adminFirstName": "Admin First Name",
    "adminLastName": "Admin Last Name",
    "validation": {
      "companyNameRequired": "Company name is required.",
      "branchCodeRequired": "Branch code is required.",
      "branchNameRequired": "Branch name is required.",
      "adminUsernameRequired": "Admin username is required.",
      "adminEmailRequired": "Admin email is required.",
      "adminPasswordMinLength": "Password must be at least 6 characters.",
      "adminFirstNameRequired": "Admin first name is required.",
      "adminLastNameRequired": "Admin last name is required."
    }
  }
}
